import { str as crc32Str } from "crc-32";

/**
 * Return unsigned int crc32 checksum
 */
export function crc32sum(data: string) {
  return crc32Str(data) >>> 0;
}
